var api = "https://api.qingcigame.com";

var obj = {
    index: function () {
        this.returnCurrentPage(); // 是否返回当前页面
        this.preloading(); // 预加载
        this.indexSwiper(); // 首页大轮播
        this.indexBind(); // 各种事件绑定
        this.dataTake(); // 数据采集
        this.share(); // 分享
        this.downloadSelection(); // 下载包选择
    },
    // 下载包选择
    downloadSelection() {
        // 链接数组
        const links = [
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163150.apk', app: 'https://apps.apple.com/cn/app/%E6%9C%80%E5%BC%BA%E8%9C%97%E7%89%9B/id1507966188'},
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163145.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160867&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163146.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160868&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163147.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160869&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163148.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160870&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163149.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160871&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163152.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160874&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163153.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160875&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163154.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160876&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163155.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160877&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163156.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160878&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163157.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160879&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163158.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160880&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163159.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160881&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
            { apk: 'https://download4.qcplay.com/apk-v2/qc-kol-1163160.apk', app: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1160882&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188' },
        ];

        function getTypeParam(url) {
            const urlParams = new URLSearchParams(url.split('?')[1]);
            return urlParams.get('type');
        }

        // 获取 type 参数的值
        const typeValue = getTypeParam(_code);

        $('.download-box').on('click', 'a', function () {
            const className = $(this).attr('class');
            const isIOS = className.includes('ios-btn');
            const linkType = typeValue !== null ? typeValue : 0;
            const url = isIOS ? links[linkType].app : links[linkType].apk;
            
            location.href = url;
        });
        
    },
    // 是否返回当前页面
    returnCurrentPage() {
        window.addEventListener('pageshow', function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        });
    },
    // 图片资源预加载
    preloading: function () {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function (e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loading_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function (e) {
            //加载完成执行操作
            $('.loading_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.float-time').addClass('float-time-ani')
            $('.index').removeClass('loading');
            $('.bg').addClass('bg-ani');

            setTimeout(function () {
                $('.preloading').remove();
            }, 1000);
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/leading/images/pc/m_dt_sz.png',
            '//static.qcplay.com/snail/leading/images/pc/m_dt_t.png',
            '//static.qcplay.com/snail/leading/images/pc/m_jdt.png',
        ]);
    },
    // 首页轮播
    indexSwiper: function () {
        var mySwiper = new Swiper('.swiper-container', {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 0,
            mousewheelControl: true,
            resistanceRatio: 0,
            onInit: function (swiper) {
                swiperAnimate(swiper);

                function Ani(btn, page) {
                    $(btn).on('click', function () {
                        mySwiper.slideTo(page, 500, true);
                    });
                }

                // 使用循环来简化重复代码
                for (let i = 1; i <= 5; i++) {
                    Ani(`.nav-btn-${i}`, i - 1);
                }

                var aniLink01 = Ani('.arrow-b', '1');
            },
            onSlideChangeStart: function (swiper) {
                let activeIndex = swiper.activeIndex + 1;
                const $navFixed = $('.nav-fixed');
                const $floatCode = $('.float-code');

                $navFixed.toggleClass('nav-fixed-show', activeIndex > 1);
                $floatCode.toggleClass('float-code-ani', activeIndex === 1);
                $navFixed.find(`.nav-btn-${activeIndex}`).addClass('on').siblings('li').removeClass('on');

                $('.footer').removeClass('footer-on');

                swiperAnimate(swiper);
            },
            onSlideChangeEnd: function (swiper) {
                swiperAnimate(swiper);
            },
        });

        var mySwiper2 = new Swiper('.swiper-container2', {
            loop: true,
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            nextButton: '.next',
            prevButton: '.prev',
            slidesPerView: 'auto',
            autoplayDisableOnInteraction: false,
            autoplay: 5000,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            coverflow: {
                rotate: 0, // 旋转的角度
                stretch: 13, // 拉伸   图片间左右的间距和密集度
                depth: 10, // 深度   切换图片间上下的间距和密集度
                modifier: 12, // 修正值 该值越大前面的效果越明显
            }
        });

    },

    indexBind: function () {

        // 第一页面
        $('.gwcz-btn').click(function () {
            var dataUrl = $(this).attr('data-url');
            setTimeout(function () {
                location.href = dataUrl;
            }, 1000);
        })

        // 第一页，开启视频
        $('.video_btn').on('click', function (event) {
            var _this = $(this);
            var _thisData = _this.attr('data');
            var _thisSrc = _this.attr('dataSrc');
            $('#media-play-01').attr("src", _thisSrc);
            $('#media-play-01')[0].play();
            $('.popup-video').addClass('popup-video-01').fadeIn();
        });

        // 第一页，关闭视频
        $('.close-btn').click(function (event) {
            $('.popup').fadeOut();
            setTimeout(function () {
                $('.popup').removeClass('popup-video-01');
                $('.popup').removeClass('popup-video-02');
            }, 500);
            $('#media-play-01')[0].pause();
        });

        // 第一页，二维码按钮
        $('.changes-btn a').click(function (event) {
            $('.footer').removeClass('footer-on');
            $('.float-code').toggleClass('float-code-ani');
        });

        // 第一页，适龄弹窗
        $(".year_box").click(function () {
            $(".year_pop").fadeIn();
        });

        // 第一页，回归福利
        $('.hgfl-btn').on('click', function () {
            const data = $(this).attr('data');
            showRewardBox(data);
        });

        // 第二页，5个新春活动的切换
        $(".page li").on('click', function () {
            $(this).addClass("active").siblings().removeClass("active");
        })

        let now = '';

        function checkTime(now) {
            // 将 now 转换为 Date 对象
            const nowDate = new Date(now.replace(' ', 'T'));

            // 创建日期对象和对应的操作
            const checkDates = [
                { date: '2025-01-14 00:00:00', selector: '.p1 a', href: 'https://pay.qingcigame.com/pay?gameId=39' },
                { date: '2025-01-20 12:00:00', selector: '.p2 a', href: 'https://l.taptap.cn/0pBsnkJr?channel=rep-rep_ts53yv1f1yq' },
                { date: '2025-01-23 10:00:00', selector: '.p3 a', href: 'https://l.taptap.cn/hSlWukPi?channel=rep-rep_tabdaul43of' },
                { date: '2025-01-24 05:00:00', selector: '.p4 a', href: 'https://pay.qingcigame.com/pay?gameId=39' },
                { date: '2025-01-24 08:00:00', selector: '.p5 a', href: 'https://snail.qingcigame.com/adver/62/13.html' },
            ];

            // 遍历日期对象并执行相应操作
            checkDates.forEach(item => {
                const itemDate = new Date(item.date.replace(' ', 'T')); // 将日期字符串转换为 Date 对象
                if (nowDate > itemDate) {
                    $(item.selector).addClass('on').attr('href', item.href);
                }
            });
        }

        $.ajax({
            url: "https://api.qingcigame.com/snail/web-activity",
            type: "get",
            xhrFields: {
                withCredentials: true
            },
            success: function (json) {
                console.log(json.data.time);
                now = json.data.time;
                checkTime(now);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("AJAX request failed: " + textStatus, errorThrown);
            }
        });

        $('.page-content').on('click', 'a', function () {
            if (!$(this).hasClass('on')) {
                layer.msg('活动未到开启时间<br/>敬请期待', { time: 1000 });
            }
        });


        // 第三页，神墟道具显示切换
        $('.benefits-rewards').on('click', 'li', function () {
            const data = $(this).attr('data');
            showRewardBox(data);
        });

        // 第五页，神墟进入
        $('.point').click(function (event) {
            var jumpUrl = $(this).attr('url');
            $('.content-05').addClass('content-05-ani');
            $('.prevent').fadeIn();

            setTimeout(function () {
                location.href = jumpUrl;
            }, 1800);
        });

        // 第六页，页尾
        $('.footer').click(function (event) {
            var _this = $(this);
            _this.hasClass('footer-on') ? _this.removeClass('footer-on') : _this.addClass('footer-on');
            $('.float-code').addClass('float-code-ani');
        });

        // 其他，点击弹窗背景关闭弹窗
        $('.popup_wrap').click(function (event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.popup_wrap').fadeOut();
            }
        });

        // 其他，奖励弹窗
        function showRewardBox(data) {
            $('.reward-pop-wrap').fadeIn();
            for (let i = 0; i < 6; i++) {
                $('.reward-pop-box').removeClass(`reward-box-${i}`);
            }
            $('.reward-pop-box').addClass(`reward-box-${data}`);
        }
    },

    dataTake: function () {
        $('.take').click(function (event) {
            var data = $(this).attr('take-data');
            console.log(data);
            obj.countNum(data);
        });

        $('.share-box').on('click', '.social-share-icon', function () {
            const messages = {
                'icon-qq': 'pc-分享-QQ空间二维码',
                'icon-qzone': 'pc-分享-QQ空间分享',
                'icon-weibo': '分享-分享-微博',
                'icon-wechat': 'pc-分享-微信-扫描二维码进入'
            };

            for (const [iconClass, message] of Object.entries(messages)) {
                if ($(this).is(`.${iconClass}`)) {
                    console.log(message);
                    obj.countNum(message);
                    break; // 找到匹配后退出循环
                }
            }
        });
    },

    // 获取当前hash的具体参数
    getQueryVariable: function (variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    },

    share: function () {
        // 第一页，分享
        $('#share-2').share({ sites: ['qq', 'qzone', 'weibo', 'wechat'] });

        var share_icon = 'https://download4.qcplay.com/qcgame-api/etA0ZWRfXTztqENhUxQl6Ell9eV60FsVrG4UWPRB.png'
        var share_big_title = '《最强蜗牛》- 鹂蜗一起庆双春';
        var share_min_title = '新年新气象，神墟&新春版本1月24日惊喜来袭！';
        outside.share(share_icon, share_big_title, share_min_title);
    },
    // 阿里云埋点
    countNum: function (data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 200);
    }
}